import React, {useMemo, useRef} from "react";
import {
  IonButton,
  IonButtons,
  IonContent,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonLabel,
  IonModal,
  IonSelect,
  IonSelectOption,
  IonSpinner,
  IonTitle,
  IonToolbar,
} from "@ionic/react";
import { Controller, useForm } from "react-hook-form";
import InputErrorMessage from "../../../components/InputErrorMessage";
import { useDispatch, useSelector } from "react-redux";

import { chevronBack } from "ionicons/icons";

import updateDocument from "../../../store/documentUpdate/actions/updateDocument";
import { setUpdatedDocument } from "../../../store/documentUpdate";
import { addDocumentHistory } from "../../../store/documentUpdate/actions/addDocumentHistory";
import { selectUpdateDocumentStatus } from "../../../store/documentUpdate/selectors/selectUpdateDocumentStatus";
import { selectDocument } from "../../../store/documentShow/selectors/selectDocument";
import { selectShowUpdateDocumentModal } from "../../../store/documentShow/selectors/selectShowUpdateDocumentModal";
import { setShowUpdateDocumentModal } from "../../../store/documentShow";
import { selectDocumentCategory } from "../../../store/utils/selectors/selectDocumentCategory";

export const ModalUpdateDocument: React.FC = () => {
  const document = useSelector(selectDocument);
  const showModal = useSelector(selectShowUpdateDocumentModal);
  const updateDocumentStatus = useSelector(selectUpdateDocumentStatus);
  const { id, title, category } = document;
  const documentCategoryList = useSelector(selectDocumentCategory);

  const dispatch = useDispatch();

  const {
    register,
    control,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: { title, category, id },
  });

  const onSubmit = async (data: any) => {
    try {
      dispatch(setUpdatedDocument(data));

      await dispatch(updateDocument());
      await dispatch(addDocumentHistory("actualizó los datos del acuerdo"));

      dispatch(setShowUpdateDocumentModal(false));
    } catch (error) {}
  };

  const docFormSubmit: any = useRef(null);

  const controllers = useMemo(()=>{
    return [({ field: { onChange, value } }:any) => (
      <IonInput
        value={value ? value : document?.title}
        placeholder="Ingrese el titulo"
        onIonChange={({ detail: { value } }) => onChange(value)}
        {...register("title", {
          required: "Campo obligatorio.",
        })}/>
    ),({ field: { onChange, value } }:any) => (
      <IonSelect
        value={value || document.category}
        okText="Aceptar"
        cancelText="Cancelar"
        placeholder="Seleccione tipo"
        onIonChange={({ detail: { value } }) => onChange(value)}
        {...register("category", {
          required: "Campo obligatorio.",
        })}
      >
        {documentCategoryList.map((type) => (
          <IonSelectOption value={type} key={`option-select-${type.id}`}>
            {type.name}
          </IonSelectOption>
        ))}
      </IonSelect>
    )]
  },[])

  return (
    <>
      <IonModal isOpen={showModal} onDidDismiss={() => dispatch(setShowUpdateDocumentModal(false))}>
        <IonHeader translucent>
          <IonToolbar>
            <IonButtons slot="start">
              <IonButton onClick={() => dispatch(setShowUpdateDocumentModal(false))}>
                <IonIcon icon={chevronBack} />
              </IonButton>
            </IonButtons>
            <IonTitle>Editar acuerdo</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent class="ion-padding">
          <form noValidate onSubmit={handleSubmit(onSubmit)}>
            <IonItem lines="inset">
              <IonLabel position="stacked">Titulo</IonLabel>
              <Controller
                name="title"
                control={control}
                render={controllers[0]}
              />
            </IonItem>
            <InputErrorMessage errorMessage={errors.title?.message || ""} />
            <IonItem lines="inset">
              <IonLabel position="stacked">Tipo de documento</IonLabel>
              <Controller
                name="category"
                control={control}
                render={controllers[1]}
              />
            </IonItem>
            {/* {errors.category && <InputErrorMessage errorMessage={errors.category?.message || ""} />} */}

            <br />

            <IonButton
              ref={docFormSubmit}
              fill="solid"
              type="submit"
              style={{ display: "none" }}
            ></IonButton>
          </form>
        </IonContent>
        <IonFooter style={{ display: "flex" }} class="ion-padding-end">
          <span style={{ display: "flex", flex: 1 }}></span>
          <IonButton fill="solid" onClick={() => docFormSubmit.current.click()}>
            {updateDocumentStatus === "pending" ? (
              <>
                <IonSpinner />
                <span className="ion-margin-start">Actualizando acuerdo</span>
              </>
            ) : (
              <span>actualizar acuerdo</span>
            )}
          </IonButton>
        </IonFooter>
      </IonModal>
    </>
  );
};
